import * as vp from 'vopay';
import React from 'react';

import styles from './SocialButtons.module.scss';

const { Box, Title, Button } = vp;

export type SocialButtonsProps = {
  title: string;
};

const SocialButtons = ({ title }: SocialButtonsProps): React.JSX.Element => (
  <div className={styles.container}>
    <div className={styles.lineContainer}>
      <span>or</span>
    </div>
    <Title title={title} size="xxsm" bold />
    <Box mt="sm" gap="md">
      <Button
        id="google-btn"
        label="Google"
        width="100%"
        color="none"
        round
        textColor="#2D2D2D"
        size="xlg"
        borderColor="#C4C4C4"
        onClick={() => {}}
        icon="google"
        iconLocation="left"
        iconSize="sm"
      />
      <Button
        id="facebook-btn"
        label="Facebook"
        width="100%"
        color="none"
        round
        textColor="#2D2D2D"
        size="xlg"
        borderColor="#C4C4C4"
        onClick={() => {}}
        icon="facebook"
        iconLocation="left"
      />
      <Button
        id="linkedin-btn"
        label="Linkedin"
        width="100%"
        color="none"
        round
        textColor="#2D2D2D"
        size="xlg"
        borderColor="#C4C4C4"
        onClick={() => {}}
        icon="linkedin"
        iconLocation="left"
      />
    </Box>
  </div>
);

export default SocialButtons;
